import { useContext } from 'react';
import {
  useAnimatedReaction,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { ScrollContext } from '../context/ScrollContext';

/**
 * scrollY가 threshold를 넘는 시점에만 withTiming을 실행하는 훅.
 *
 * useAnimatedStyle 안에서 매 프레임 withTiming을 생성하는 대신,
 * boolean 전환 시점에만 한 번 애니메이션을 시작합니다.
 *
 * @returns SharedValue<number> - 0 또는 1로 애니메이션되는 값
 */
export const useScrollThresholdValue = (
  threshold: number,
  duration: number,
) => {
  const { scrollY } = useContext(ScrollContext);
  const animatedValue = useSharedValue(0);

  useAnimatedReaction(
    () => (scrollY?.value ?? 0) > threshold,
    (isOver, prevIsOver) => {
      if (isOver !== prevIsOver) {
        animatedValue.value = withTiming(isOver ? 1 : 0, { duration });
      }
    },
  );

  return animatedValue;
};
